module.exports = __webpack_public_path__ + "static/xometry-logo-76d918144c8d5879f82e116b6744ae83.png";